import { RouteParamValue } from 'vue-router';

export type ID = number | string;

export const LINKS = {
  TABS: {
    DASHBOARD: '/tabs/dashboard',
    INFOMED: '/tabs/infomed',
    RESSOURCES: '/tabs/infomed/ressources',
    LABELS: '/tabs/infomed/label',
    OFFERS: '/tabs/offers',
    PROFILE: '/tabs/profile',
    TELECARE_PHONE: '/tabs/telecare/phone',
    TELECARE_PATIENTS: '/tabs/telecare/patients',
    INVOICES_BASE: '/tabs/profile/invoice',
  },
  MISSIONS: {
    BASE: '/missions',
    ID: (missionId: ID) => `/missions/${missionId}`,
    ASSIGNATION: (missionId: ID) => `/missions/${missionId}/assignation`,
    SELECT_SLOTS: (missionId: ID) => `/missions/${missionId}/select-slots`,
    SELECTED_SLOTS_CONFIRMATION: `/missions/selected-slots-confirmation`,
    DECLINE: (missionId: ID) => `/missions/${missionId}/decline`,
    SLOT: {
      LIST: (missionId: ID) => `/missions/${missionId}/slots`,
      ID: (missionId: string | RouteParamValue[], slotId: string | RouteParamValue[]) =>
        `/missions/${missionId}/slots/${slotId}`,
      PATIENTS: (missionId: ID, slotId: ID) => `/missions/${missionId}/slots/${slotId}/patients`,
    },
    END: '/missions/end',
    PROTOCOL: {
      BASE: (missionId: ID) => `/missions/${missionId}/protocol`,
    },
  },
  APPOINTMENTS: {
    ASSIGNATION: {
      BASE: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/assignation`,
      DECLINE: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/assignation/decline`,
      ACCEPTED: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/assignation/accepted`,
      SLOTS: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/assignation/slots`,
    },
    BASE: '/tabs/dashboard/appointments',
    ID: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}`,
    EDIT_FREQUENCY: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/edit-frequency`,
    EDIT_FREQUENCY_RULE: (appointmentId: ID, frequencyRuleId?: ID) =>
      `/tabs/dashboard/appointments/${appointmentId}/edit-frequency-rule/${frequencyRuleId ?? ''}`,
    EDIT_DATETIME: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/edit-datetime`,
    END_SCREEN: (appointmentId: ID) => `/tabs/dashboard/appointments/${appointmentId}/end-screen`,
  },
  PROFILE: {
    CHART: '/tabs/profile/charte-libheros',
    DETAIL: '/tabs/profile/detail',
    LABELS: '/tabs/profile/labels',
    FLOW: {
      DETAIL: '/tabs/profile/flow/detail',
      FORM: '/tabs/profile/flow/form',
    },
    CONTACT: '/tabs/profile/contact',
    CARES: '/tabs/profile/cares',
    COVER_AREA: '/tabs/profile/cover-area',
    COLLEAGUES: '/tabs/profile/colleagues',
    SCHEDULE: '/tabs/profile/schedule',
    SCHEDULE_ADD_SLOT: '/tabs/profile/schedule/add-slot',
    VISIBILITY: '/tabs/profile/visibility',
    SPONSORSHIP: '/tabs/profile/sponsorship',
  },
  MYAPPOINTMENT: '/tabs/dashboard/my-appointment',
  AUTH: {
    SIGN_IN: '/auth/signin',
    SIGN_UP: {
      PRO_STEP: '/auth/sign-up/pro-step',
      JOB_STEP: '/auth/sign-up/job-step',
      AREA_STEP: '/auth/sign-up/area-step',
      CARES_STEP: '/auth/sign-up/cares-step',
    },
    RESET_PASSWORD: {
      CONFIRM_EMAIL: '/auth/reset-password/confirm-email',
      CONFIRM_EMAIL_OTP: '/auth/reset-password/confirm-email-otp',
      INPUT: '/auth/reset-password/input',
    },
  },
  PATIENT: {
    DETAILS: {
      BASE: '/patients',
      ID: (patientId: ID) => `/patients/${patientId}`,
      NAME: (patientId: ID) => `/patients/${patientId}/name`,
      GENDER: (patientId: ID) => `/patients/${patientId}/gender`,
      BIRTH_DATE: (patientId: ID) => `/patients/${patientId}/birth-date`,
      EMAIL: (patientId: ID) => `/patients/${patientId}/email`,
      PHONE: (patientId: ID) => `/patients/${patientId}/phone`,
    },
  },
  SCREENING: {
    FLOW: '/screening/flow',
    PRE_FILTER: '/screening/flow/pre-filter',
    TOOL_LIST: '/screening/flow/tool-list',
    PATIENT_INFO: '/screening/flow/patient-info',
    QUESTIONNAIRE: '/screening/flow/questionnaire',
    RESULTS: '/screening/flow/results',
  },
  NOTIFICATION: '/notification',
  ERROR: '/error',
  EXTERNAL: {
    BLOG: 'https://blog.libheros.fr/',
    CONTACT: {
      MAIL: 'support@libheros.fr',
      PHONE: '+33175434447',
    },
    FAQ: 'https://libheros.zendesk.com/hc/fr/categories/360001200520-Professionnels-de-sant%C3%A9',
    PRIVACY_POLICY: 'https://www.libheros.fr/a-propos/politique-confidentialite',
    CGU: 'https://www.libheros.fr/a-propos/cgps',
    SPONSORSHIP_CONDITIONS:
      'https://csb3f4de42cd3fax4b41xa29.blob.core.windows.net/pdf/20220531_infographie_parrainage_VF.pdf',
    SPONSORSHIP_SIGNUP: 'https://app.lib-heros.com/signup',
    APP_STORE_ONELINK: 'http://onelink.to/ngyzw5',
  },
} as const;
